<mat-form-field
  class="w-100"
  appearance="outline"
  [matTooltip]="tooltip ?? '' | translate"
>
  <mat-label>{{ title | translate }}</mat-label>
  <input
    *ngIf="type !== 'number'"
    matInput
    [formControl]="control"
    [type]="type"
    (change)="onInputChange($event)"
  />
  <input
    *ngIf="type === 'number'"
    matInput
    [formControl]="control"
    type="number"
    [min]="min || min === 0 ? min : ''"
    [max]="max || max === 0 ? max : ''"
    [step]="step"
    (change)="onInputChange($event)"
    appLimitDecimalDigits
    [decimals]="maxDecimals"
  />

  <span matSuffix *ngIf="icon">
    <mat-chip style="background-color: transparent; padding: 0"
      ><mat-icon color="primary">{{ icon }}</mat-icon></mat-chip
    >
  </span>
  <mat-hint *ngIf="control?.hasError('max')">
    {{ "MAX" | translate }} {{ control.errors!["max"]["max"] }} &nbsp;
  </mat-hint>
  <mat-hint *ngIf="control?.hasError('min')">
    {{ "MIN" | translate }} {{ control.errors!["min"]["min"] }} &nbsp;
  </mat-hint>
  <mat-hint *ngIf="showHint"> {{ hint | translate }}. &nbsp; </mat-hint>
  <mat-hint
    *ngIf="control?.hasError('required') && !showHint && showRequiredLabel"
    >{{ "REQUIRED" | translate }}</mat-hint
  >
  <mat-error *ngIf="getServerError()">
    {{ getServerError() }}
  </mat-error>
</mat-form-field>
